import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import apiClient from '../utils/api';
import ProductCard from '../components/ProductCard';

interface Producto {
  productoId: string;
  nombre: string;
  descripcion: string;
  precio?: number;
  precioTexto?: string;
  imageUrl?: string;
  category: string;
}

const HomePage = () => {
  const [productos, setProductos] = useState<Producto[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProductos();
  }, []);

  const loadProductos = async () => {
    try {
      const response = (await apiClient.getProductos()) as { productos: Producto[] };
      setProductos(response.productos || []);
    } catch (error) {
      console.error('Error loading productos:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-milo-beige-light">
      {/* Hero Section */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-6xl md:text-7xl font-serif text-milo-black mb-6"
          >
            MILO Pastelería
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-milo-gray max-w-2xl mx-auto font-light"
          >
            Productos artesanales hechos con dedicación y los mejores ingredientes
          </motion.p>
        </div>
      </section>

      {/* Productos Grid */}
      <section className="py-16 px-4 pb-32">
        <div className="max-w-6xl mx-auto">
          <h2 className="section-title">Nuestros Productos</h2>

          {loading ? (
            <div className="text-center">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-milo-gold"></div>
              <p className="mt-4 text-milo-gray">Cargando productos...</p>
            </div>
          ) : productos.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-milo-gray text-lg">No hay productos disponibles en este momento</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {productos.map((producto) => (
                <ProductCard key={producto.productoId} producto={producto} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default HomePage;
